module.exports = __webpack_public_path__ + "../resources/img/ic_re_snow_solid.0fd94380.svg";